import { render } from "./addreturn.vue?vue&type=template&id=40fc5756&scoped=true"
import script from "./addreturn.vue?vue&type=script&lang=js"
export * from "./addreturn.vue?vue&type=script&lang=js"

import "./addreturn.vue?vue&type=style&index=0&id=40fc5756&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fc5756"]])

export default __exports__